module.exports = __webpack_public_path__ + "static/media/profile.74f9bc86.svg";